import * as axios from 'axios';

const httpClient = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    // timeout: 2000,
    headers: {
        Authorization: 'Bearer keyHYZsUY9ABfd6rp',
        // "Content-Type": "application/json",
    }
});

export default httpClient;